import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class OfficeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/RealEstate/Office/OfficeBrowser")
	}

	render() {
		return (
			<Activity 
				name="Office"
				RenderedComponent={this.RenderedComponent}
				context="Office"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(OfficeActivity)
